import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ConfirmationModal,
  ContentArea,
  ErrorSuccessModal
} from "../../components/commons";
import {
  AddEditTimeSheet,
  TimeSheetHeader,
  TimeSheetList,
} from "../../components/TimeSheet";

import {
  GetAssignedClientsToUserPayloadType,
} from "../../commonTypes/authTypes";
import {
  getAssignedClientsToUserAction,
  resetSession,
} from "../../redux/auth";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { ClientType, LoginResponseType } from "../../redux/auth/authTypes";
import { JobTrackerListingType } from "../../redux/listing/listingTypes";
import {
  getMasterDataActivityCodeAction,
  getMasterDataHolidayCalenderAction,
  resetHolidayCalenderList,
  resetHolidayCalenderTotalCount,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../redux/masterData";
import {
  addTimeSheetAction,
  deleteTimeSheetAction,
  editTimeSheetAction,
  getTimeSheetDataAction,
  getTimeSheetStatus,
  resetEnableBackdatedTimesheetEntry,
  resetTimeSheetError,
  resetTimeSheetListing,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetTimeSheetTotalTime,
} from "../../redux/timeSheet";
import {
  AddEditTimeSheetDataPayloadType,
  DeleteTimeSheetDataPayloadType,
  GetTimeSheetDataPayloadType,
} from "../../commonTypes/timeSheetTypes";
import "../../components/TimeSheet/timesheet.scss";
import { Toaster, toast } from "react-hot-toast";
import TimeSheetLoader from "../../components/commons/SkeltonLoader/TimeSheetLoader";
import { getClientDirectoryListAction } from "../../redux/clientDirectory";
import OpenTimeSheetUserModal from "../../components/TimeSheet/OpenTimeSheetUserModal";
import CopyTimeSheet from "../../components/TimeSheet/CopyTimeSheet";
import { getJobsListAction, resetJobsList } from "../../redux/jobs";
import OpenTimeSheetUnfilledDateModal from "../../components/TimeSheet/OpenTimeSheetUnfilledDateModal";
import {
  convertMsToHourMinSec
} from "../../utils/commonFunctions";
import {
  GetAllMasterDataActivityCodePayloadType,
  GetHolidayCalenderPayloadType,
} from "../../commonTypes/masterDataTypes";
import { HolidayCalenderListType } from "../../redux/masterData/masterTypes";
import { useMenuCheck } from "../../customHooks/useMenuCheck";

type RadioTypes = {
  id: string;
  name: string;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined | Element;
};

export type AddEditTimeSheetDataType = {
  timeSheetEntryType: string;
  clientName: any;
  jobDetails: any;
  startTime: string;
  endTime: string;
  activityCode: string;
  comment: string;
};

export type HolidaysTimeSheetDataType = {
  date: string;
  holidayName: string;
};

type AppProps = {
  token: string | null;
  clientList: ClientType[] | [];
  jobTrackerListing: [] | JobTrackerListingType[];
  activityCodeListing: [];
  timeSheetListing: any;
  fetching: boolean;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  totalTime: number;
  loginData: LoginResponseType;
  dispatchResetJobTrackerListing: () => void;
  dispatchGetAllClientsAction: (data: any) => void;
  dispatchGetTimeSheetDataAction: (data: GetTimeSheetDataPayloadType) => void;
  dispatchGetClientsActiveJobAction: (data: any) => void;
  dispatchGetMasterDataActivityCode: (
    data: GetAllMasterDataActivityCodePayloadType
  ) => void;
  dispatchUpdateTimeSheetDataAction: (
    data: AddEditTimeSheetDataPayloadType
  ) => void;
  dispatchAddTimeSheetData: (data: AddEditTimeSheetDataPayloadType) => void;
  dispatchDeleteTimeSheetDataAction: (
    data: DeleteTimeSheetDataPayloadType
  ) => void;
  dispatchResetTimeSheetTotalTime: () => void;
  dispatchResetTimeSheetListing: () => void;
  dispatchResetSession: () => void;
  dispatchResetTimeSheetError: () => void;
  dispatchResetTimeSheetSuccess: () => void;
  dispatchResetTimeSheetMessage: () => void;
  dispatchResetTimeSheetStatusCode: () => void;
  dispatchGetAssignedClientsToUserAction: (data: any) => void;
  holidayCalenderList: HolidayCalenderListType[] | [];
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterDataHolidayCalenderListing: () => void;
  dispatchResetMasterDataHolidayCalenderListTotal: () => void;
  enableBackdatedTimesheetEntry: boolean;
  dispatchResetTimeSheetStatus:() => void;
  dispatchGetTimeSheetStatus:(data:string) => void;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "billable",
    name: "Billable",
  },
  {
    id: "non-billable",
    name: "Non-Billable/Paid Non-Billable",
  },
];

const TimeSheet = ({
  token,
  error,
  statusCode,
  success,
  message,
  fetching,
  clientList,
  loginData,
  jobTrackerListing,
  activityCodeListing,
  timeSheetListing,
  totalTime,
  dispatchResetJobTrackerListing,
  dispatchGetClientsActiveJobAction,
  dispatchAddTimeSheetData,
  dispatchGetTimeSheetDataAction,
  dispatchResetSession,
  dispatchDeleteTimeSheetDataAction,
  dispatchGetMasterDataActivityCode,
  dispatchUpdateTimeSheetDataAction,
  dispatchResetTimeSheetError,
  dispatchResetTimeSheetSuccess,
  dispatchResetTimeSheetMessage,
  dispatchResetTimeSheetTotalTime,
  dispatchResetTimeSheetListing,
  dispatchResetTimeSheetStatusCode,
  dispatchGetAssignedClientsToUserAction,
  holidayCalenderList,
  dispatchGetMasterDataHolidayCalenderAction,
  dispatchResetMasterStatusCode,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterError,
  dispatchResetMasterDataHolidayCalenderListing,
  dispatchResetMasterDataHolidayCalenderListTotal,
  enableBackdatedTimesheetEntry,
  dispatchGetTimeSheetStatus,
  dispatchResetTimeSheetStatus
}: AppProps) => {
  let editDays:any = process.env.REACT_APP_RESTRICT_EDIT_DAYS;
  const [timeSheetDate, setTimeSheetDate] = useState<string>(
    `${new Date().getDate().toString().padStart(2, "0")}-${(
      new Date().getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${new Date().getFullYear()}`
  );
  const [timeSheetEntryType, setTimeSheetEntryType] = useState(
    RADIO_OPTIONS[0].id
  );
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [finalJobList, setFinalJobList] = useState<
    DropDownItemType[] | [] | any
  >([]);
  const [isViewUserDropDown, setIsViewUserDropDown] = useState<boolean>(false);
  const [finalActivityCodeData, setFinalActivityCodeData] = useState<
    DropDownItemType[] | []
  >([]);
  const [allActivityCode, setAllActivityCode] = useState<any>([]);
  const [comment, setComment] = useState<string>("");
  const [timeSheetError, setTimeSheetError] = useState<any>({
    dateError: "",
    clientError: "",
    jobError: "",
    activityError: "",
    startError: "",
    endError: "",
  });
  const [jobSelected, setJobSelected] = useState<any>({
    value: null,
    label: "Select Job Type",
  });

  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [sharedJob, setSharedJob] = useState(false);
  const [endTime, setEndTime] = useState<any>();
  const [startTime, setStartTime] = useState<any>();
  const [isEdit, setIsEdit] = useState<string>("");
  const [isCopy, setIsCopy] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const [copyData, setCopyData] = useState<any>({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showTimeSheetUserModal, setShowTimeSheetUserModal] = useState(false);
  const [showTimeSheetUnfilledDate, setShowTimeSheetUnfilledDate] =
    useState(false);
  const [deleteTimeSheetId, setDeleteTimeSheetId] = useState("");
  const [activityCode, setActivityCode] = useState<any>({
    value: null,
    label: "Select Activity code",
  });
  const [copyTimeSheet, setCopyTimeSheet] = useState<boolean>(false);
  const [copyComment, setCopyComment] = useState<boolean>(false);
  const [copyDate, setCopyDate] = useState<string>("");
  const [persistComment, setPersistComment] = useState<string>("");
  const [timeDifference, setTimeDifference] = useState<string>("0.00");
  const [holidaysData, setHolidaysData] = useState<HolidaysTimeSheetDataType[]>(
    []
  );

  //========== User Management ==========//
  const [addTimeSheet, setAddTimeSheet] = useMenuCheck();
  const [editTimeSheet, setEditTimeSheet] = useMenuCheck();
  const [getTimeSheet, setGetTimeSheet] = useMenuCheck();
  const [deleteTimeSheet, setDeleteTimeSheet] = useMenuCheck();
  //====================//

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterDataHolidayCalenderListing();
    dispatchResetMasterDataHolidayCalenderListTotal();
    dispatchResetMasterStatusCode();
    dispatchResetTimeSheetStatusCode();
    dispatchResetTimeSheetStatus()
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetMessage();
    dispatchResetTimeSheetError();
    dispatchResetTimeSheetTotalTime();
    dispatchResetTimeSheetListing();
    dispatchResetJobTrackerListing();
    handleReset();
    resetTimeSheetError();
    setPersistComment("");
    setIsEdit("");
    setAddTimeSheet("Add timesheet", "menu");
    setEditTimeSheet("Update timesheet", "menu");
    setGetTimeSheet("Get timesheet", "menu");
    setDeleteTimeSheet("Delete timesheet", "menu");
    // setFinalJobList([]);
    if (token) {
      let finalData: GetAllMasterDataActivityCodePayloadType = { token };
      dispatchGetMasterDataActivityCode(finalData);
      dispatchGetTimeSheetStatus(token)
      dispatchGetAssignedClientsToUserAction({
        token,
        user_id: loginData?.user_id,
      });
    }
    // future use
    // if (token) {
    //   let finalData = {
    //     token,
    //     country: "India",
    //   };
    //   dispatchGetMasterDataHolidayCalenderAction(finalData);
    //   //   dispatchGetCountryListAction(finalCountryData);
    // }
  }, []);

  // useEffect(() => {
  //   if (holidayCalenderList?.length) {
  //     let finalData = holidayCalenderList.map((el: HolidayCalenderListType) => {
  //       return {
  //         date: formatDateInYear(el?.date),
  //         holidayName: el?.description ? el?.description : "",
  //       };
  //     });

  //     setHolidaysData(finalData);
  //   } else {
  //     setHolidaysData([]);
  //   }
  // }, [holidayCalenderList]);

const isEditingAllowed = () => {
  const [day, month, year]:any = timeSheetDate?.split("-")?.map(Number);
  const timeSheetDateObj = new Date(year, month - 1, day); 
  const today = new Date();

  const diffInTime = today.getTime() - timeSheetDateObj.getTime();
  const diffInDays = diffInTime / (1000 * 60 * 60 * 24); 

  return diffInDays <= editDays; 

};
const editDateTimesheet = isEditingAllowed()||enableBackdatedTimesheetEntry;

  useEffect(() => {
    setSharedJob(false);
  }, [timeSheetEntryType]);
  useEffect(() => {
    if (!!isEdit && !!editData?.activity_code) {
      const findingActivityCode: any = allActivityCode?.find(
        (obj: any) => obj.value == editData?.activity_code
      );
      setActivityCode({ ...findingActivityCode });
    }

    if (!isEdit) {
      setIsEdit("");
    }
    setFinalActivityCodeData([]);
  }, [timeSheetEntryType]);

  //change copy comment

  useEffect(() => {
    if ((!!isEdit && clientSelected?.value) || (!!isEdit && sharedJob)) {
      let finalData = {
        clientCode: sharedJob ? "" : clientSelected?.value,
        token,
        filterStatus: "Open",
        sharedJob: sharedJob,
      };
      dispatchGetClientsActiveJobAction(finalData);
    } else if (Object.values(copyData)?.length && clientSelected?.value) {
      let finalData = {
        clientCode: sharedJob ? "" : clientSelected?.value,
        token,
        filterStatus: "Open",
        sharedJob: sharedJob,
      };
      dispatchGetClientsActiveJobAction(finalData);
    }
  }, [clientSelected?.value, copyData?.client_details?.client_code, sharedJob]);

  useEffect(() => {
    if (timeSheetDate && token) {
      dispatchGetTimeSheetDataAction({ date: timeSheetDate, token });
      setSharedJob(false);
      setIsEdit("");

      if (copyDate != timeSheetDate) {
        setIsCopy(false);
        setCopyComment(false);
        handleReset();
        resetTimeSheetError();
      }
    }
  }, [timeSheetDate]);

  useEffect(() => {
    dispatchResetTimeSheetStatusCode();
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetMessage();
    if (!isCopy) {
      setJobSelected({
        value: null,
        label: "Select Job Type",
      });
      setClientSelected({
        value: null,
        label: "Select Client",
      });
      setActivityCode({
        value: null,
        label: "Select Activity code",
      });
      if (timeSheetListing?.data?.length > 0) {
        let time = getEditTime(
          timeSheetListing?.data[timeSheetListing?.data?.length - 1]?.end_time
        );
        setStartTime(time);
      } else {
        setStartTime("");
      }
      setEndTime("");
      setComment("");
      setIsEdit("");
      if (timeSheetListing?.data?.length > 0) {
        let time = getEditTime(
          timeSheetListing?.data[timeSheetListing?.data?.length - 1]?.end_time
        );
        setStartTime(time);
      }
    }
  }, [timeSheetListing]);

  useEffect(() => {
    if ((isEdit || isCopy) && !sharedJob) {
      const findingJobListing: any = finalJobList?.find(
        (obj: any) => obj.value == editData?.job?.code
      );
      setJobSelected({ ...findingJobListing });
    }
  }, [finalJobList]);

  useEffect(() => {
    let diff = new Date(endTime).getTime() - new Date(startTime).getTime();
    let convertedDate = convertMsToHourMinSec(diff);
    let splitedDate = convertedDate?.split(":");
    let hour = splitedDate[0];
    let min = +splitedDate[1];

    if (+hour > 0) {
      min += +hour * 60;
    }
    if (+hour == 0 && +min == 0) {
      setTimeDifference("0.00");
    } else {
      let percentageTime = +(+min / 60);
      let finalTime = percentageTime?.toFixed(4)?.toString();
      setTimeDifference(finalTime);
    }
    if (startTime) {
      setTimeSheetError((prev: any) => ({
        ...prev,
        startError: "",
      }));
    }
    if (endTime) {
      setTimeSheetError((prev: any) => ({
        ...prev,
        endError: "",
      }));
    }
  }, [startTime, endTime]);

  useEffect(() => {
    if (!clientSelected?.value && !sharedJob) {
      setFinalJobList([]);
    }
    resetTimeSheetError();
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetMessage();
    dispatchResetTimeSheetError();
    if (!isEdit && !isCopy) {
      if (timeSheetListing?.data?.length > 0) {
        let time = getEditTime(
          timeSheetListing?.data[timeSheetListing?.data?.length - 1]?.end_time
        );
        setStartTime(time);
      } else {
        setStartTime("");
      }
      setEndTime("");

      setJobSelected({
        value: null,
        label: "Select Job Type",
      });
      setClientSelected({
        value: null,
        label: "Select Client",
      });
      setActivityCode({
        value: null,
        label: "Select Activity code",
      });
      setFinalJobList([]);
      setComment("");
      setIsEdit("");
      setTimeSheetError({
        dateError: "",
        clientError: "",
        jobError: "",
        activityError: "",
        startError: "",
        endError: "",
      });
    }
  }, [timeSheetEntryType, sharedJob]);

  useEffect(() => {
    if (clientList?.length) {
      let finalClientData = clientList?.map((client: ClientType) => {
        return {
          value: client?.client_code,
          label: `(${client?.client_code})  ${client?.company_name}`,
        };
      });
      setFinalClientList(finalClientData);
    }
  }, [clientList]);

  useEffect(() => {
    if (jobTrackerListing?.length > 0) {
      let finalJobsData = jobTrackerListing?.map((job: any) => {
        return {
          value: job?.job_id,
          label: sharedJob
            ? getClientCodeClientName(job)
            : `${job?.job_type}_${job?.period_ended}(${job?.job_id})`,
        };
      });

      setFinalJobList(finalJobsData);
    } else {
      setFinalJobList([]);
    }
  }, [jobTrackerListing]);

  const getLabel = (job: any) => {
    return (
      <>
        <div>{job.activity_code}</div>
        <div className="inside-card-sub-heading">{job.description}</div>
      </>
    );
  };

  const getClientCodeClientName = (job: any) => {
    return (
      <>
        <div>{`${job?.job_type}_${job?.period_ended}(${job?.job_id})`}</div>
        <div className="inside-card-sub-heading">{`${job?.client_details?.company_name} (${job?.client_details?.client_code})`}</div>
      </>
    );
  };

  useEffect(() => {
    let activityCodeData: any = [];

    if (timeSheetEntryType === "billable") {
      activityCodeData = activityCodeListing?.filter(
        (data: any) => data.activity_code_type === "Billable"
      );
    } else if (timeSheetEntryType === "non-billable") {
      activityCodeData = activityCodeListing?.filter(
        (data: any) => data.activity_code_type === "Non-Billable"
      );
    }
    let totalActivityCode = activityCodeListing?.map((job: any) => {
      return {
        value: job._id,
        label: getLabel(job),
      };
    });
    setAllActivityCode([...totalActivityCode]);
    let finalActivityCodeData = activityCodeData?.map((job: any) => {
      return {
        value: job._id,
        label: job.activity_code,
        description: job.description,
      };
    });

    setFinalActivityCodeData(finalActivityCodeData);
  }, [activityCodeListing, timeSheetEntryType]);

  useEffect(() => {
    if (isEdit || isCopy) {
      let finalActivityCode: any = {};
      if (isEdit) {
        finalActivityCode = finalActivityCodeData?.find(
          (el: any) => el.value == editData?.activity_code_details?._id
        );
      } else if (isCopy) {
        finalActivityCode = finalActivityCodeData?.find(
          (el: any) => el.value == copyData?.activity_code_details?._id
        );
      }

      if (finalActivityCode?.value) {
        setActivityCode({ ...finalActivityCode });
      } else {
        setActivityCode({
          value: null,
          label: "Select Activity code",
        });
      }
    }
  }, [finalActivityCodeData]);

  useEffect(() => {
    if (!isEdit && !isCopy) {
      setIsEdit("");
      setEditData({});
      handleReset();
    }
  }, [isEdit, isCopy]);

  useEffect(() => {
    if (isCopy && copyData?.start_time && copyData?.end_time) {
      setClientSelected({
        value: null,
        label: "Select Client",
      });
      let start_time = getEditTime(copyData?.start_time);
      let end_time = getEditTime(copyData?.end_time);

      if (!isEdit) {
        setComment(copyData?.comments);
      }
      setStartTime(start_time);
      setEndTime(end_time);
      setTimeSheetEntryType(copyData?.type == 1 ? "billable" : "non-billable");

      const findingClient_code = finalClientList?.find(
        (obj: any) => obj?.value == copyData?.client_details?.client_code
      );
      setClientSelected({ ...findingClient_code });

      const findingActivityCode: any = allActivityCode?.find(
        (obj: any) => obj?.value == copyData?.activity_code_details?._id
      );
      setActivityCode({ ...findingActivityCode });

      const findingJobListing: any = finalJobList?.find(
        (obj: any) => obj?.value == copyData?.job?.code
      );
      setJobSelected({ ...findingJobListing });

      if (copyData?.shared_job) {
        setSharedJob(true);
      }
    }
  }, [copyData, isCopy]);

  useEffect(() => {
    if (isCopy && copyData?.start_time && copyData?.end_time) {
      const findingJobListing: any = finalJobList?.find(
        (obj: any) => obj?.value == copyData?.job?.code
      );
      setJobSelected({ ...findingJobListing });
    }
  }, [copyData, finalJobList, isCopy]);

  useEffect(() => {
    if (copyComment === false) {
      setCopyData((prev: any) => ({ ...prev, comments: "" }));
    } else if (copyComment) {
      setCopyData((prev: any) => ({ ...prev, comments: persistComment }));
    }
  }, [copyComment]);

  const handleChangeTimeSheetEntryType = (value: string) => {
    setTimeSheetEntryType(value);
  };

  const handleShowConfirmationModal = (id: string) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteTimeSheetId(id);
  };

  const handleCopyTimeSheetModal = () => {
    setCopyTimeSheet(!copyTimeSheet);
  };

  const handleCopyTimeSheetChangeDate = (data: any) => {
    setCopyDate(data);
    setTimeSheetDate(data);
  };

  const handleChange = (data: any, name: string) => {
    if (name === "time-sheet-date") {
      setTimeSheetDate(data);
      if (Object.values(copyData)?.length !== 0) {
        setCopyData({});
      }
      setCopyData({});
      setTimeSheetError((prev: any) => ({
        ...prev,
        dateError: "",
      }));
    } else if (name === "Activity-code") {
      setActivityCode(data);
      setTimeSheetError((prev: any) => ({
        ...prev,
        activityError: "",
      }));
    } else if (name === "comments") {
      setComment(data.target.value);
    } else if (name === "client" || name === "job") {
      setJobSelected({
        value: null,
        label: "Select Job Type",
      });
      if (name === "client") {
        setClientSelected(data);
        setTimeSheetError((prev: any) => ({
          ...prev,
          clientError: "",
        }));
        if (data && token) {
          dispatchResetJobTrackerListing();
          let finalData = {
            clientCode: data.value,
            token,
            filterStatus: "Open",
            sharedJob: sharedJob,
          };
          dispatchGetClientsActiveJobAction(finalData);
        }
      } else if (name === "job") {
        setJobSelected(data);
        setTimeSheetError((prev: any) => ({
          ...prev,
          jobError: "",
        }));
      }
    }
  };

  const getTime = (date: any) => {
    let time = new Date(date).toLocaleTimeString("en-US");
    let timeArray = time?.split(":");
    let slicedMeredian = timeArray[timeArray.length - 1].slice(-2);
    return timeArray[0] + ":" + timeArray[1] + slicedMeredian;
  };

  const handleAddTimeSheetData = () => {
    if (
      (timeSheetEntryType === "non-billable" &&
        timeSheetDate &&
        activityCode?.value &&
        endTime &&
        startTime) ||
      (timeSheetEntryType === "billable" &&
        timeSheetDate &&
        jobSelected.value &&
        clientSelected?.value &&
        timeSheetDate &&
        activityCode?.value &&
        endTime &&
        startTime) ||
      ((timeSheetEntryType === "billable" && sharedJob) &&
        timeSheetDate &&
        (jobSelected.value || clientSelected?.value) &&
        timeSheetDate &&
        activityCode?.value &&
        endTime &&
        startTime)
    ) {
      let jobTrackerData: any = jobTrackerListing?.find(
        (job: any) => job?.job_id === jobSelected?.value
      );
      let finalData: any = {
        type: timeSheetEntryType === "billable" ? 1 : 2,
        client_code:
        timeSheetEntryType === "non-billable"
        ? "":
     
          (timeSheetEntryType === "billable" && sharedJob)
            ? jobTrackerData?.client_details?.client_code
            : clientSelected.value,
        date: timeSheetDate,
        job:
          timeSheetEntryType === "non-billable"
            ? {}
            : {
                code: jobTrackerData?.job_id,
                job_name: jobTrackerData?.job_type,
                job_status: jobTrackerData?.current_job_state,
              },
        start_time: getTime(startTime),
        end_time: getTime(endTime),
        activity_code: activityCode?.value,
        comments: comment,
        token,
      };
      if (isEdit) {
       
        dispatchUpdateTimeSheetDataAction({ id: isEdit, ...finalData });
        setEditData({});
        setCopyData({});
        setFinalJobList([]);
        setCopyTimeSheet(false);
        setIsCopy(false);
      } else {
        setCopyData({});
        dispatchAddTimeSheetData(finalData);
        if (!sharedJob) {
          setFinalJobList([]);
        }
        setCopyTimeSheet(false);
        setIsCopy(false);
      }
    } else {
      setTimeSheetError((prev: any) => ({
        ...prev,
        ...(!timeSheetDate
          ? { dateError: "Date Required !" }
          : { dateError: "" }),
        ...(!jobSelected?.value
          ? { jobError: "Job Is Required" }
          : { jobError: "" }),
        ...(!clientSelected?.value
          ? {
              clientError: "Client Required !",
            }
          : { clientError: "" }),
        ...(!activityCode?.value
          ? {
              activityError: "Please choose activity code",
            }
          : { activityError: "" }),
        ...(!endTime
          ? {
              endError: "Required !",
            }
          : { endError: "" }),
        ...(!startTime
          ? {
              startError: "Required !",
            }
          : { startError: "" }),
      }));
    }
  };

  const handleDeleteTimeSheet = (id: number | string) => {
    dispatchDeleteTimeSheetDataAction({ id, token });
    setIsCopy(false);
    setIsEdit("");
    setEditData({});
    setCopyData({});
    handleReset();
  };

  function resetTimeSheetError() {
    setTimeSheetError({
      dateError: "",
      clientError: "",
      jobError: "",
      activityError: "",
      startError: "",
      endError: "",
    });
  }

  function getEditTime(date: any) {
    let splitedTime = date?.split(":");
    let amPm = splitedTime[1]?.slice(-2);
    let hour = +splitedTime[0];
    let min = splitedTime[1]?.substring(0, 2);

    if (amPm === "PM" && +hour <= 11) {
      hour += 12;
    }
    if (hour == 12 && amPm == "AM") {
      hour = 0;
    } else if (hour == 12 && amPm == "PM") {
      hour = 12;
    }

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm: string | number = today.getMonth() + 1; // Months start at 0!
    let dd: string | number = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return new Date(`${yyyy} ${mm} ${dd} ${hour}:${min}:00`);
  }

  const handleEdit = (data: any) => {
    setIsCopy(false);
    setCopyData({});
    setEditData({ ...data });
    resetTimeSheetError();
    let start_time = getEditTime(data?.start_time);
    let end_time = getEditTime(data?.end_time);

    setIsEdit(data._id);
    setComment(data?.comments);
    setStartTime(start_time);
    setEndTime(end_time);
    setTimeSheetEntryType(data?.type == 1 ? "billable" : "non-billable");

    const findingClient_code = finalClientList?.find(
      (obj: any) => obj?.value == data?.client_details?.client_code
    );
    setClientSelected({ ...findingClient_code });

    const findingActivityCode: any = allActivityCode?.find(
      (obj: any) => obj?.value == data?.activity_code_details?._id
    );
    setActivityCode({ ...findingActivityCode });

    const findingJobListing: any = finalJobList?.find(
      (obj: any) => obj?.value == data?.job?.code
    );
    setJobSelected({ ...findingJobListing });
  };

  useEffect(() => {
    if (sharedJob) {
      if (isEdit && jobSelected?.value) {
        setJobSelected({
          value: null,
          label: "",
        });
      }
      setFinalJobList([]);
      setJobSelected({
        value: null,
        label: "Select Job Type",
      });

      if (timeSheetEntryType === "billable") {
        let finalData = {
          token,
          filterStatus: "Open",
          sharedJob,
        };
        dispatchGetClientsActiveJobAction(finalData);
        setClientSelected("");
      }
    }
  }, [sharedJob, token]);

  const handleChangeStatus = () => {
    setSharedJob(!sharedJob);
  };
  const handleCopy = (e: any, data: any) => {
    setCopyComment(false);
    e.stopPropagation();
    setPersistComment(data?.comments);
    if (copyComment === false) {
      setCopyData({ ...data, comments: "" });
    } else {
      setCopyData({ ...data });
    }
    resetTimeSheetError();
  };

  function handleReset() {
    setJobSelected({
      value: null,
      label: "Select Job Type",
    });
    setClientSelected({
      value: null,
      label: "Select Client",
    });
    setActivityCode({
      value: null,
      label: "Select Activity code",
    });
    if (timeSheetListing?.data?.length > 0) {
      let time = getEditTime(
        timeSheetListing?.data[timeSheetListing?.data?.length - 1]?.end_time
      );
      setStartTime(time);
    } else {
      setStartTime("");
    }
    setEndTime("");
    setComment("");
    setIsEdit("");
    setEditData({});
    setTimeDifference("0.00");
    setTimeSheetEntryType(RADIO_OPTIONS[0].id);
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetError();
              handleReset();
            }}
          />
        );
      }
    }
    if (success === 1 && message && message?.length > 0) {
      dispatchResetTimeSheetSuccess();
      dispatchResetTimeSheetMessage();
      dispatchResetTimeSheetListing();
      toast.success(message, { duration: 3500 });

      if (timeSheetDate && token) {
        dispatchGetTimeSheetDataAction({ date: timeSheetDate, token });
      }
    }

    return false;
  };
  const handleOpenTimeSheetUserView = () => {
    setShowTimeSheetUserModal(!showTimeSheetUserModal);
    setIsViewUserDropDown(!isViewUserDropDown);
  };
  const handleOpenTimeSheetUnfilledDate = () => {
    setShowTimeSheetUnfilledDate(!showTimeSheetUnfilledDate);
  };


  return (
    <div>
      <CommonHeader title="Time Sheet" />
      <ContentArea noPadding>
        <div className="row">
          <div className="col-md-12 d-flex  mt-4 bottom-border">
            <TimeSheetHeader
              date={timeSheetDate}
              handleDateChange={handleChange}
              setTimeSheetDate={setTimeSheetDate}
              timeSheetError={timeSheetError}
              handleOpenTimeSheetUserView={handleOpenTimeSheetUserView}
              handleOpenTimeSheetUnfilledDate={handleOpenTimeSheetUnfilledDate}
              holidaysData={holidaysData}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6" style={{ padding: "40px" }}>
            <AddEditTimeSheet
              radioOptions={RADIO_OPTIONS}
              timeSheetEntryType={timeSheetEntryType}
              handleSetRadioValue={handleChangeTimeSheetEntryType}
              timeSheetError={timeSheetError}
              handleAddTimeSheetData={handleAddTimeSheetData}
              handleChange={handleChange}
              finalClientList={finalClientList}
              clientSelected={clientSelected}
              finalJobList={finalJobList}
              jobSelected={jobSelected}
              startTime={startTime}
              endTime={endTime}
              setEndTime={setEndTime}
              setStartTime={setStartTime}
              comment={comment}
              activityCode={activityCode}
              finalActivityCodeData={finalActivityCodeData}
              isEdit={isEdit}
              copyData={copyData}
              timeDifference={timeDifference}
              fetching={fetching}
              showTimeSheetUserModal={showTimeSheetUserModal}
              showTimeSheetUnfilledDate={showTimeSheetUnfilledDate}
              handleChangeStatus={handleChangeStatus}
              sharedJob={sharedJob}
              addTimeSheet={addTimeSheet}
              editTimeSheet={editTimeSheet}
              editDateTimesheet={editDateTimesheet}
            />
          </div>
          <div
            className="col-md-6"
            style={{
              background: "#e8ecf0",
              padding: "35px",
              height: "665px",
              overflow: "auto",
            }}
          >
            {fetching &&
            showTimeSheetUserModal === false &&
            showTimeSheetUnfilledDate === false ? (
              <TimeSheetLoader times={5} />
            ) : (
              getTimeSheet && (
                <TimeSheetList
                  timeSheetListing={timeSheetListing}
                  handleDeleteTimeSheet={handleShowConfirmationModal}
                  handleEdit={handleEdit}
                  totalTime={totalTime}
                  handleCopy={handleCopy}
                  handleCopyTimeSheetModal={handleCopyTimeSheetModal}
                  finalClientList={finalClientList}
                  finalJobList={finalJobList}
                  allActivityCode={activityCodeListing}
                  timeSheetEntryType={timeSheetEntryType}
                  sharedJob={sharedJob}
                  editTimeSheet={editTimeSheet}
                  deleteTimeSheet={deleteTimeSheet}
                  editDateTimesheet={editDateTimesheet}
                />
              )
            )}
          </div>
        </div>
      </ContentArea>

      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal(deleteTimeSheetId);
            setFinalJobList([]);
            handleReset();
          }}
          isOpen={showConfirmationModal}
          title={"Delete TimeSheet Entry"}
          message={`Are you sure you want to delete this entry`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            handleDeleteTimeSheet(deleteTimeSheetId);
            handleShowConfirmationModal(deleteTimeSheetId);
          }}
        />
      )}
      {showTimeSheetUserModal && (
        <OpenTimeSheetUserModal
          isOpen={showTimeSheetUserModal}
          toggle={() => {
            handleOpenTimeSheetUserView();
          }}
          isViewUserDropDown={isViewUserDropDown}
        />
      )}
      {showTimeSheetUnfilledDate && (
        <OpenTimeSheetUnfilledDateModal
          isOpen={showTimeSheetUnfilledDate}
          toggle={() => {
            dispatchResetTimeSheetStatusCode();
            dispatchResetTimeSheetSuccess();
            dispatchResetTimeSheetMessage();
            handleOpenTimeSheetUnfilledDate();
          }}
        />
      )}
      {copyTimeSheet && (
        <CopyTimeSheet
          isOpen={copyTimeSheet}
          toggle={() => {
            handleCopyTimeSheetModal();
          }}
          handleDateChange={handleCopyTimeSheetChangeDate}
          date={timeSheetDate}
          setCopyData={setCopyData}
          setComment={setComment}
          copyData={copyData}
          setIsCopy={setIsCopy}
          setIsEdit={setIsEdit}
          copyComment={copyComment}
          setCopyComment={setCopyComment}
        />
      )}
      <Toaster />
      {/* {fetching&&<Loader/>} */}

      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  loginData: state.auth.loginData,
  clientList: state.auth.assignedClientsToUserList,
  activityCodeListing: state.masterData.masterDataActivivtyCodeListing,
  jobTrackerListing: state.jobs.jobsList,
  timeSheetListing: state.timeSheet.timeSheetData,
  totalTime: state.timeSheet.totalTime,
  holidayCalenderList: state.masterData.holidayCalenderList,
  enableBackdatedTimesheetEntry: state.timeSheet.enableBackdatedTimesheetEntry,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClientsActiveJobAction: (data: any) =>
    dispatch(getJobsListAction(data)),
  dispatchResetJobTrackerListing: () => dispatch(resetJobsList()),
  dispatchGetAllClientsAction: (data: any) =>
    dispatch(getClientDirectoryListAction(data)),
  dispatchGetMasterDataActivityCode: (
    data: GetAllMasterDataActivityCodePayloadType
  ) => dispatch(getMasterDataActivityCodeAction(data)),
  dispatchGetTimeSheetDataAction: (data: GetTimeSheetDataPayloadType) =>
    dispatch(getTimeSheetDataAction(data)),
  dispatchAddTimeSheetData: (data: AddEditTimeSheetDataPayloadType) =>
    dispatch(addTimeSheetAction(data)),
  dispatchDeleteTimeSheetDataAction: (data: DeleteTimeSheetDataPayloadType) =>
    dispatch(deleteTimeSheetAction(data)),
  dispatchUpdateTimeSheetDataAction: (data: AddEditTimeSheetDataPayloadType) =>
    dispatch(editTimeSheetAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetStatusCode: () => dispatch(resetTimeSheetStatusCode()),
  dispatchResetTimeSheetTotalTime: () => dispatch(resetTimeSheetTotalTime()),
  dispatchResetTimeSheetListing: () => dispatch(resetTimeSheetListing()),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetMasterDataHolidayCalenderListing: () =>
    dispatch(resetHolidayCalenderList()),
  dispatchResetMasterDataHolidayCalenderListTotal: () =>
    dispatch(resetHolidayCalenderTotalCount()),
  dispatchGetTimeSheetStatus: (data:string) => dispatch(getTimeSheetStatus(data)),
  dispatchResetTimeSheetStatus: () => dispatch(resetEnableBackdatedTimesheetEntry()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheet);
